// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-btn {
  background-color: #fff;
  color: #344054;
  border: 1px solid lightgray;
  padding: 8px 15px 8px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);
  font-weight: 500;
}

.preview-btn:hover,
.preview-btn:after {
  background-color: #0a56ae;
  color: #fff;
}

.dl-btn {
  background-color: #0a56ae;
  color: #fff;
  border: 1px solid #fff;
  padding: 8px 15px 8px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);
  font-weight: 500;
}

.dl-btn:hover, .dl-btn:active {
  background-color: #fff;
  color: #0a56ae;
  border: 1px solid #0a56ae;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/formelements/TableElement.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;AACJ;;AAEA;;EAEE,yBAAA;EACA,WAAA;AACF;;AAEA;EACI,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,cAAA;EACA,yBAAA;AACJ","sourcesContent":[".preview-btn {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid lightgray;\n    padding: 8px 15px 8px 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);\n    font-weight: 500;\n}\n\n.preview-btn:hover,\n.preview-btn:after {\n  background-color: #0a56ae;\n  color: #fff;\n}\n\n.dl-btn {\n    background-color: #0a56ae;\n    color: #fff;\n    border: 1px solid #fff;\n    padding: 8px 15px 8px 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);\n    font-weight: 500;\n}\n\n.dl-btn:hover, .dl-btn:active {\n    background-color: #fff;\n    color: #0a56ae;\n    border: 1px solid #0a56ae;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
